import {createSelector} from 'reselect';

import {hasPermission, hasSharedPermission} from '../../../helpers/models/accessHelpers';
import {PermissionsEnum} from '../../../models/api/roleModel';
import {getAccess, getRoles} from '../dataSelectors';
import {getUserNamespace} from '../teammates/teammatesSelectors';

/*
 * Permissions.
 */

export const getHasPermission = createSelector(
  [getRoles, getAccess, getUserNamespace],
  // Note: `adminOverride` is _not_ meant to be passed to `true` if a given teammate is global admin.
  // Being a global admin doesn't override the permissions you have been given in a specific team.
  // `adminOverride` was made in case we want to check if the user can edit the settings of a resource.
  (roles, access, userNamespace) =>
    (namespace: string, permission: PermissionsEnum, adminOverride: boolean = false) =>
      hasPermission(roles, access, namespace, userNamespace, permission, adminOverride),
);

export const getHasSharedPermission = createSelector(
  [getRoles, getAccess, getUserNamespace],
  (roles, access, userNamespace) => (permission: PermissionsEnum) =>
    hasSharedPermission(roles, access, permission, userNamespace),
);
